<script setup lang="ts">
import ButtonHamburger from '@buttons/button-hamburger.vue';
import PartAppLogo from '@parts/part-app-logo.vue';
import ModalMobileMenu from '@/components/modals/modal-mobile-menu.vue';
import { useModal } from 'bootstrap-vue-next';

const { show: showMobileMenuModal } = useModal('modal-mobile-menu');
</script>

<template>
	<div class="part-header" v-bind="$attrs">
		<div class="part-header__inner">
			<div class="wrapper">
				<div class="part-header__row">
					<part-app-logo class="part-header__logo" />
					<button-hamburger
						@click="showMobileMenuModal"
						class="part-header__hamburger"
					/>
				</div>
			</div>
		</div>
	</div>
	<modal-mobile-menu />
</template>

<style lang="scss">
.part-header {
	padding: 2rem 0;
	&__row{
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	&__hamburger {
		margin-right: -1rem;
	}
	&__inner {
		max-width: var(--max-page-width);
		margin: auto;
	}
}
</style>
